import axios from 'axios'
import { REACT_APP_API } from '../../../config'

export async function deleteDictionaryTranslation(id) {
  const response = await axios.delete(
    `${REACT_APP_API}/dictionary/${id}`,
  )
  return response.data
}